import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allSites } from 'app/mocks/data/park/sites'

import { api } from 'app/utils/constants'

import { SitePayload } from 'app/types/park/site'

export const updateSite = http.patch(
    `${process.env.REACT_APP_API_ADDRESS}/${api.park.sites.DETAILS}`,
    async ({ request, params }) => {
        const payload = await request.json()
        const { id } = params

        const payloadParsed = SitePayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return new HttpResponse(null, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        const siteFound = allSites.find((site) => site.id.toString() === id)

        // No site found
        if (!siteFound) {
            return new HttpResponse(null, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        const siteUpdated = {
            ...siteFound,
            ...payloadParsed.data,
        }

        return HttpResponse.json(siteUpdated)
    },
)
